<template>
  <div v-if="dataPermission.includes('CNPS_CALENDAR_WK_GROUP_UPDATE')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết nhóm công việc</h1>
      <div style="float: right">
        <button
          @click="$router.push({ path: `/group-calendar-afs` })"
          class="f12 font-medium btn btn-outline-secondary"
        >
          <i class="bx bx-left-arrow-alt"></i> Quay lại
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body px-20 form-row">
        <div class="col-sm-12 mb-3">
          <div class="form-detail">
            <h1>Thông tin nhóm công việc</h1>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Sản phẩm<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ detail.service }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Mã nhóm<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ detail.groupCode }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Tên nhóm<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ detail.groupName }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Thời gian hoàn thành<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ detail.finishTime }} &nbsp; {{ detail.finishTimeType | mapTypeTime() }}
                </p>
              </div>
            </div>
            <div class="form-group form-row" v-if="detail.note">
              <label for="" class="col-sm-4 col-form-label"
                >Mô tả<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ detail.note }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { CalendarAfsService } from '@/services/calendar-afs.service'
  import { mapGetters } from 'vuex'
  export default {
    data() {
      return {
        id: this.$route.params.id,
        detail: {},
      }
    },
    created() {
      this.fetchData()
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    methods: {
      async fetchData() {
        try {
          const data = await CalendarAfsService.detailGroupCalendar({
            id: this.id,
          })
          if (data.success) {
            this.detail = data.data
          }
        } catch (error) {
          console.log(error)
        }
      },
    },
  }
</script>
